import { render, staticRenderFns } from "./HighlightLendersListItem.vue?vue&type=template&id=3fe00cf1&"
import script from "./HighlightLendersListItem.vue?vue&type=script&lang=js&"
export * from "./HighlightLendersListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports